import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "reduxStore";
import { selectAreLearningTasksLoading, selectLearningTasks } from "selectors/learningTask";
import { getLearningTasksAction } from "slices/learningTasks";
import FlexItem from "./shared/layout/FlexItem";
import FlexContainer from "./shared/layout/FlexContainer";
import { H1, H2 } from "./shared/primitives/Heading";
import Paragraph from "./shared/primitives/Paragraph";
import { useParams } from "react-router-dom";
import { selectLearningCategory } from "selectors/learningCategory";
import { getLearningCategoriesAction } from "slices/learningCategories";
import { ButtonAsLink } from "./shared/primitives/Button";
import { routes } from "config";
import { learningTaskAnswerVersionStatusPhrases } from "./helpers/translations";
export default function LearningCategory() {
    const dispatch = useAppDispatch();
    const learningTasks = useSelector(selectLearningTasks);
    const isLoadingLearningTasks = useSelector(selectAreLearningTasksLoading);
    const { learningCategoryId } = useParams();
    const learningCategory = useSelector(selectLearningCategory(learningCategoryId));
    const getLearningCategories = () => dispatch(getLearningCategoriesAction());
    const getLearningTasks = () => {
        if (learningCategoryId) {
            dispatch(getLearningTasksAction(learningCategoryId));
        }
    };
    useEffect(() => {
        if (learningCategory) {
            getLearningTasks();
        }
        else {
            getLearningCategories();
        }
    }, [learningCategory]);
    if (!learningCategory)
        return null;
    return (React.createElement(FlexContainer, { fullWidth: true, flexDirection: "column" },
        React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(H1, { solo: true, color: "primary" }, learningCategory.name)),
        learningCategory.description && (React.createElement(FlexItem, { column: 1 / 1 },
            React.createElement(Paragraph, null, learningCategory.description))),
        !isLoadingLearningTasks && (React.createElement(FlexContainer, { flexWrap: "wrap", fullWidth: true }, learningTasks.map((lt, i) => {
            var _a;
            const latestVersion = (_a = lt.answer) === null || _a === void 0 ? void 0 : _a.versions[0];
            return (React.createElement(FlexItem, { key: lt.id, display: "flex", flexDirection: "column", flexGrow: 1, flexShrink: 0, alignItems: "center", backgroundColor: i % 2 === 0 ? "lightGray" : "white", desktop: { padding: "3rem 5%" }, column: 1 / 1 },
                React.createElement(H2, null, lt.title),
                latestVersion && (React.createElement(FlexContainer, { flexDirection: "column", margin: "0 0 1rem 0" },
                    React.createElement(Paragraph, null, learningTaskAnswerVersionStatusPhrases[latestVersion.status]))),
                React.createElement(ButtonAsLink, { to: routes.learningCategories(`/${learningCategoryId}/tasks/${lt.id}`) }, "Aufgabe anzeigen")));
        })))));
}
